import cn from 'classnames'
import { observer } from 'mobx-react'

import { Text, TextColor } from '@/components/Text'

import styles from './LangSwitcher.module.scss'

interface LangItemProps {
	title: string;
	active?: boolean;
	activeColor: TextColor;
	inactiveColor: TextColor;
	onClick?: () => void;
}

export const LangItem = observer(function LangItem(props: LangItemProps) {
  const {
		title,
		active,
		activeColor,
		inactiveColor,
		onClick,
	} = props

	const color = active ? activeColor : inactiveColor;

	return (
		<div className={styles.item} onClick={onClick}>
			<Text
				variant='text-3-semibold'
				color={color}
			>
				{title}
			</Text>
		</div>
	)
})
